import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import UserWordsStyles from './UserWordsStyles';
import WordCEFRStyles from './WordCEFRStyles';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import ModalAlert from "./ModalAlert"
import Button from "@mui/material/Button";
import SubtitleStylesSettings from "./SubtitleStylesSettings"
export default function StylesSettings({ handleShowSubtitleStyleBox, handleFullScreen, handlePlayingStatus }) {
  const [value, setValue] = React.useState('1');
  const [openModalAlert, setOpenModalAlert] = React.useState(false);

  const handleOpenModalAlert = () => {
    setOpenModalAlert(!openModalAlert)
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      {openModalAlert ? <ModalAlert handleOpenModalAlert={handleOpenModalAlert} openModalAlert={openModalAlert} handleFullScreen={handleFullScreen} handleShowSubtitleStyleBox={handleShowSubtitleStyleBox} /> :
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList variant="scrollable" onChange={handleChange} >
              <Tab icon={<FormatColorFillIcon fontSize="small" />} iconPosition="start" label="تنظیمات زیرنویس" value="1" />
              <Tab icon={<FormatColorTextIcon fontSize="small" />} iconPosition="start" label=" لغات کاربر" value="2" />
              <Tab icon={<SpellcheckIcon fontSize="small" />} iconPosition="start" label="سطح بندی لغات" value="3" />
            </TabList>
          </Box>
          <Box sx={{ display: value == 1 ? "block" : "none" }}>
            <SubtitleStylesSettings handlePlayingStatus={handlePlayingStatus} handleOpenModalAlert={handleOpenModalAlert} />
          </Box>
          <Box sx={{ display: value == 2 ? "block" : "none" }}>
            <UserWordsStyles handlePlayingStatus={handlePlayingStatus} handleOpenModalAlert={handleOpenModalAlert} />
          </Box>
          <Box sx={{ display: value == 3 ? "block" : "none" }}>
            <WordCEFRStyles handlePlayingStatus={handlePlayingStatus} handleOpenModalAlert={handleOpenModalAlert} />
          </Box>
          {/* <TabPanel value="2">Item Two</TabPanel>
            <TabPanel value="3">Item Three</TabPanel> */}
          <Button
            onClick={handleShowSubtitleStyleBox}
            variant="contained"
            color="secondary"
            sx={{ right: "31px", position: "absolute", my: 1 }}
          >
            ذخیره و بستن
          </Button>
        </TabContext>
      }
    </Box>
  );
}
